import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-[#1e3a5f] text-white py-12 sm:py-16 lg:py-20">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        {/* Top Section */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12 mb-12">
          {/* Company Info */}
          <div>
            <h3 className="text-3xl sm:text-4xl font-light mb-6">おかやま屋根工事</h3>
            <div className="space-y-3 text-gray-300">
              <p className="text-sm sm:text-base">
                〒700-0000<br />
                岡山市北区○○町1-2-3
              </p>
              <p className="text-sm sm:text-base">
                電話番号：086-012-3456
              </p>
              <p className="text-sm sm:text-base">
                FAX：086-012-3457
              </p>
              <p className="text-sm sm:text-base">
                営業時間：9:00〜18:00
              </p>
            </div>
          </div>

          {/* Sitemap */}
          <div>
            <h4 className="text-lg font-bold mb-6">サイトマップ</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-gray-300 hover:text-white transition-colors duration-200 hover:underline cursor-pointer text-sm sm:text-base">
                  トップ
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-300 hover:text-white transition-colors duration-200 hover:underline cursor-pointer text-sm sm:text-base">
                  サービス内容
                </Link>
              </li>
              <li>
                <Link to="/case-studies" className="text-gray-300 hover:text-white transition-colors duration-200 hover:underline cursor-pointer text-sm sm:text-base">
                  施工事例
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-300 hover:text-white transition-colors duration-200 hover:underline cursor-pointer text-sm sm:text-base">
                  会社概要
                </Link>
              </li>
              <li>
                <Link to="/careers" className="text-gray-300 hover:text-white transition-colors duration-200 hover:underline cursor-pointer text-sm sm:text-base">
                  求人情報
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="pt-8 border-t border-white/20">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-6">
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-300 hover:text-white transition-colors duration-200 cursor-pointer"
              >
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-300 hover:text-white transition-colors duration-200 cursor-pointer"
              >
                <i className="ri-twitter-x-line text-xl"></i>
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-300 hover:text-white transition-colors duration-200 cursor-pointer"
              >
                <i className="ri-instagram-line text-xl"></i>
              </a>
            </div>
            
            <p className="text-gray-400 text-xs sm:text-sm text-center">
              © 2024 おかやま屋根工事株式会社. All rights reserved.
            </p>
            
            <div className="flex items-center gap-4">
              <a
                href="https://readdy.ai/?ref=logo"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors duration-200 text-xs sm:text-sm hover:underline cursor-pointer"
              >
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
